import React from "react";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import SendToAppWithTrackedLink from "web/react/components/send-to-app-with-tracked-link/send-to-app-with-tracked-link";
import SendToApp from "web/react/components/send-to-app/send-to-app";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { NotQuiteAURL } from "web/script/utils/url";
import styles from "./send-to-app-modal.module.css";

interface TrackedLinkProps {
    leadUrl: string;
    productId: string;
    reason: string;
}

interface SendToAppModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    url: string;
    analyticsEventLabel: string;
    productImageURL?: string | null;
    appDeepLinkURL?: URL | NotQuiteAURL;
    trackedLink?: TrackedLinkProps;
    financialIncentiveWebviewToken?: string;
    downloadCTA?: string;
    extraContent?: () => JSX.Element | null;
    onCtaClick?: React.EventHandler<React.MouseEvent>;
    onAfterOpen?: () => void;
    showShippingDisclaimer?: boolean;
}

function SendToAppModal({
    isOpen,
    onClose,
    title,
    url,
    analyticsEventLabel,
    productImageURL,
    appDeepLinkURL,
    trackedLink,
    financialIncentiveWebviewToken,
    downloadCTA,
    extraContent,
    onCtaClick,
    onAfterOpen,
    showShippingDisclaimer,
}: SendToAppModalProps): JSX.Element {
    // "Download the Lyst App for free"
    downloadCTA = downloadCTA ? downloadCTA : gettext("feed.show_more.app_overlay.cta");
    function handleOpen(): void {
        analytics.event("web_to_app", "shown", analyticsEventLabel);
        onAfterOpen?.();
    }
    function onModalClose(): void {
        analytics.event("web_to_app", "modal_dismissed", analyticsEventLabel);
        onClose();
    }

    /**
     * Returns the content for the send2app modal
     * @param {string} downloadCTA CTA string for the branchlink
     * @param {Boolean} animatedModal whether or not this send2App is in the animated modal. As some styling is changed
     */
    function sendToAppChildren(downloadCTA, animatedModal): JSX.Element {
        return !trackedLink ? (
            <SendToApp
                analyticsEventLabel={analyticsEventLabel}
                title={title}
                url={url}
                productImageURL={productImageURL}
                appDeepLinkURL={appDeepLinkURL}
                downloadCTA={downloadCTA}
                extraContent={extraContent}
                animatedModal={animatedModal}
                onCtaClick={onCtaClick}
                showShippingDisclaimer={showShippingDisclaimer}
            />
        ) : (
            <SendToAppWithTrackedLink
                analyticsEventLabel={analyticsEventLabel}
                title={title}
                url={url}
                productImageURL={productImageURL}
                downloadCTA={downloadCTA}
                className={styles.withTrackedLinkContainer}
                appDeepLinkURL={appDeepLinkURL}
                financialIncentiveWebviewToken={financialIncentiveWebviewToken}
                {...trackedLink}
            />
        );
    }

    return (
        <>
            <GenericModal isOpen={isOpen} onAfterOpen={handleOpen} onClose={onModalClose}>
                {sendToAppChildren(downloadCTA, false)}
            </GenericModal>
        </>
    );
}

export default SendToAppModal;
